import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useUser } from "../contexts/UserContext";
import SEO from "../components/SEO";

export default function Register() {
  const navigate = useNavigate();
  const { login } = useUser();

  const submit = async (e) => {
    e.preventDefault();
    const form = e.target;

    const res = await axios.post("http://localhost:8080/api/users/register", {
      name: form.name.value,
      email: form.email.value,
      phone: form.phone.value,
      password: form.password.value
    });

    login(res.data.user);
    navigate("/profil"); // 🔁 REDIRECTION
  };

  return (
    <>
    <SEO title="Connexion" description="Espace privé SCI MAYEDO" noindex={true} />
    <form onSubmit={submit}>
      <input name="name" placeholder="Nom" />
      <input name="email" placeholder="Email" />
      <input name="phone" placeholder="Téléphone" />
      <input name="password" type="password" placeholder="Mot de passe" />
      <button>S'inscrire</button>
    </form>
    </>
  );
}